import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { ScrollView, View } from "react-native"

export const ReportDetails = ({ navigation, route }) => {
    const report = route?.params?.report

    return (
        <ContainerStackScreen>
            <CustomScrollview contentContainerStyle={{ paddingBottom: 100 }} showsVerticalScrollIndicator={false}>
                <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                    {report.name}
                </BreeSerifText>
                <Spacer height={15} />
                <OpenSansText fontSize={14}>
                    Votre compte-rendu contient différents éléments concernant votre état de santé, votre programme ou
                    vos documents.
                </OpenSansText>
                <Spacer height={20} />
                <BreeSerifText color={baseColors.green.primary} fontSize={18}>
                    1. Motifs d’entrée dans le programme
                </BreeSerifText>
                <Spacer height={20} />
                <OpenSansText fontSize={14} textAlign={"left"}>
                    {report.programEnteringReason ?? "Non renseigné"}
                </OpenSansText>
                <Spacer height={15} />
                <BreeSerifText color={baseColors.green.primary} fontSize={18}>
                    2. Antécédents médicaux
                </BreeSerifText>
                <Spacer height={20} />
                <OpenSansText fontSize={14} textAlign={"left"}>
                    {report.medicalAntecedent ?? "Non renseigné"}
                </OpenSansText>
                <Spacer height={20} />
                <BreeSerifText color={baseColors.green.primary} fontSize={18}>
                    3. Les traitements
                </BreeSerifText>
                <Spacer height={20} />
                <OpenSansText fontSize={14} textAlign={"left"}>
                    {report.treatments ?? "Non renseigné"}
                </OpenSansText>
                <Spacer height={20} />
                <BreeSerifText color={baseColors.green.primary} fontSize={18}>
                    4. Conclusion du diagnostic éducatif
                </BreeSerifText>
                <Spacer height={20} />
                <OpenSansText fontSize={14} textAlign={"left"}>
                    {report.educationalDiagnosisConclusion ?? "Non renseigné"}
                </OpenSansText>
                <Spacer height={20} />
                <BreeSerifText color={baseColors.green.primary} fontSize={18}>
                    5. Le contenu du programme suivi
                </BreeSerifText>
                <Spacer height={20} />
                <OpenSansText fontSize={14} textAlign={"left"}>
                    {report.followedProgramContent ?? "Non renseigné"}
                </OpenSansText>
                <Spacer height={20} />
                <BreeSerifText color={baseColors.green.primary} fontSize={18}>
                    6. La conclusion de l’entretien d’évaluation
                </BreeSerifText>
                <Spacer height={20} />
                <OpenSansText fontSize={14} textAlign={"left"}>
                    {report.interviewConclusion ?? "Non renseigné"}
                </OpenSansText>
                <Spacer height={20} />

                {/* <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <Button
                        onPress={() => {}}
                        text="Partager(Mail)"
                        width="45%"
                        height={50}
                        fontSize={12}
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                    <Button
                        onPress={() => {}}
                        text="Exporter(PDF)"
                        width="45%"
                        height={50}
                        fontSize={12}
                        backgroundColor={baseColors.green.primary}
                        labelColor={"white"}
                    />
                </View> */}
            </CustomScrollview>
        </ContainerStackScreen>
    )
}
